import React from "react";
import { MdStars } from "react-icons/md";

export default function MembershipIcon({ size, className, style = {} }) {
  return (
    <MdStars
      size={size || 25}
      className={className || "membership-icon"}
      style={{ color: "goldenrod", backgroundColor: "White", borderRadius: 20, ...(style || {}) }}
    />
  );
}
